import React from 'react';
import { CardProps } from './types';
export default function Card({
  id,
  color,
  icon,
  title,
  subtitle,
  open,
  onToggle,
  children,
}: CardProps) {
  return (
    <div className={`cc-card cc-card-${color} ${open ? "cc-open" : ""}`} id={id}>
      <div className="cc-card-header" onClick={onToggle}>
        <div className="cc-card-icon">{icon}</div>
        <div className="cc-card-header-text">
          <div className="cc-card-title">{title}</div>
          <div className="cc-card-subtitle">{subtitle}</div>
        </div>
        <div className="cc-card-chevron">⌄</div>
      </div>
      <div className="cc-card-body">{children}</div>
    </div>
  );
}
